import type { ITranslate } from './definitions'

/**
 * Mennyit kell elmozdulnia hogy from-ból to-hoz animáljon.
 * @param fromLeft - Honnan x koordináta.
 * @param toLeft   - Hova x koordináta.
 * @param fromTop  - Honnnan y koordináta.
 * @param toTop    - Honnan  y koordináta.
 */
export default function getTranslateDirection ( // eslint-disable-line @typescript-eslint/max-params -- Legacy.
  fromLeft: number,
  toLeft: number,
  fromTop: number,
  toTop: number
): ITranslate {
  const x = toLeft - fromLeft
  const y = toTop - fromTop

  return { x, y }
}
